import React, { ReactElement, ReactNode } from 'react';
import { EmptyStateSize, useEmptyStateSizeContext } from '../contexts/size';
import { SurfaceIcons } from '../default-icons';
import { EmptyStateIcon } from './empty-state-icon';

interface EmptyStateSurfaceIconProps {
  className?: string;
  children?: ReactNode;
  icon?: ReactElement;
}

const fallbackIcon = SurfaceIcons.CloudCheckmark;

export const EmptyStateSurfaceIcon = ({
  className,
  children,
  icon,
}: EmptyStateSurfaceIconProps) => {
  const { size } = useEmptyStateSizeContext();

  if (size !== EmptyStateSize.largeSurface && size !== EmptyStateSize.mediumSurface) {
    throw new Error('The surface icon component can only be used with the large surface & medium surface sizes.');
  }

  return (
    <EmptyStateIcon
      className={className}
      fallbackIcon={fallbackIcon}
      icon={icon}
    >
      {children}
    </EmptyStateIcon>
  );
};
